module["exports"] = [
  "واحد #",
  "# طبقه"
];
